import { render, staticRenderFns } from "./Pdfviewer.vue?vue&type=template&id=627f2dbe"
import script from "./Pdfviewer.vue?vue&type=script&lang=js"
export * from "./Pdfviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports